import makeStyles from "@mui/styles/makeStyles";
import { FontFamilySwitch } from "../../utils";
export const useStyles = makeStyles((theme) => ({
    root: {},
    body: {
        border: "2px solid white",
        borderRadius: theme.palette.borderRadius,
        boxShadow: "0px 0px 16px #00000014",
        backgroundColor: "white",
        padding: "16px",
        height: `calc(100vh - 147px)`,
        overflow: "hidden",
        margin: "14px"
    },
    button: {
        borderRadius: theme.palette.borderRadius,
        boxShadow: "none",
        fontSize: "0.875rem"
    },
    filter_button: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: theme.palette.borderRadius,
        padding: "12px"
    },
    add_drawer: {
        "& .MuiDrawer-paper": {
            padding: "0px",
            width: ({ size }) => size?.width >= 600 ? "600px" : "-webkit-fill-available",
        },
    },
    add_drawer_header: {
        padding: "16px 24px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid #E4E8EE"
    },
    add_drawer_header_title: {
        fontFamily: FontFamilySwitch().extraBold, 
        fontSize: "1rem",
        color: "#091B29"
    },
    add_drawer_close_button: {
        padding: "0px"
    },
    add_drawer_body: {
        height: ({ size }) => size?.height ? (size?.height - 150) : "auto",
        padding: "24px",
        overflowY: "overlay"
    },
    add_drawer_body_view: {
        padding: "24px",
        overflowY: "overlay"
    },
    add_drawer_footer: {
        display: "flex",
        columnGap: "12px",
        padding: "24px",
    },
    add_drawer_footer_button: {
        borderRadius: theme.palette.borderRadius,
        height: "45px",
        border: "1px solid #5078E1",
        boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.08)",
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().bold, 
        color: "white"
    },
    add_drawer_footer_close_button: {
        borderRadius: theme.palette.borderRadius,
        height: "45px",
        border: "1px solid #5078E1",
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().bold, 
        color: "#5078E1",
        backgroundColor: "white",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#E4E8EE ",
        },
    },
    add_drawer_field_label: {
        color: "#98A0AC",
        fontFamily: FontFamilySwitch().semiBold, 
        fontSize: "0.875rem",
        marginBottom: "5px",
    },
    add_drawer_button_container: {
        display: "flex",
        rowGap: "8px",
        columnGap: "8px",
    },
    add_drawer_button_selected: {
        borderRadius: theme.palette.borderRadius,
        height: "45px",
        border: "1px solid #5078E1",
        backgroundColor: "#5078E1",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#5078E1 ",
        },
        fontSize: "0.875rem",
        fontFamily: FontFamilySwitch().bold, 
        color: "white",
    },
    add_drawer_button_unselected: {
        borderRadius: theme.palette.borderRadius,
        height: "45px",
        border: "1px solid #E4E8EE",
        backgroundColor: "white",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "#E4E8EE ",
        },
        fontSize: "0.75rem",
        fontFamily: FontFamilySwitch().semiBold, 
        color: "#98A0AC",
    },
}));